import React from "react";
import { nameData, descriptionData } from "./config";
import Hero from "../../components/hero";
import Layout from "../../components/Layout/Page";
import PECCERTIFICATE from "../../assets/images/peccertificate.png";

import {
  Frame,
  Container,
  SpecializationContainer,
  NameContainer,
  NamesBtn,
  SpecializationNames,
  DescriptionContainer,
  Description,
  CertificatesContainer,
  Title,
  CertificatesFrame,
  ImageContainer,
} from "./styled.components";

const Certificates = () => {
  return (
    <Layout>
      <Hero
        title="Certificates & Reports"
        SubTitle="HHH and Sons Presents a Proud Past And Will Keep The Promise For Days To Come"
      />
      <Container>
        <Hero title="PEC REGISTRATION" />
        <Frame>
          <img src={PECCERTIFICATE} alt="Frame Image" />
        </Frame>
        {/* <ImageContainer src={PECCERTIFICATE} /> */}
      </Container>
      <Hero title="Field Of Specialization" />
      <SpecializationContainer>
        <table>
          <tbody>
            {nameData.map((names, index) => (
              <tr key={index}>
                <NameContainer>
                  <NamesBtn>
                    <SpecializationNames>{names.name}</SpecializationNames>
                  </NamesBtn>
                </NameContainer>

                <DescriptionContainer>
                  <Description>
                    {descriptionData[index].description}
                  </Description>
                </DescriptionContainer>
              </tr>
            ))}
          </tbody>
        </table>
      </SpecializationContainer>
      <Title>Performance And Experience Certificates</Title>
      <CertificatesContainer>
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
        <CertificatesFrame />
      </CertificatesContainer>
    </Layout>
  );
};

export default Certificates;
